import { AccessibleText } from '@/components/AccessibleText'
import { DateTime } from '@/components/DateTime'
import ReadingTime from '@/components/ReadingTime'

import { HeadingXS } from '@/components/Typography'
import { getTruncatedText } from '@/core/utils/dom/string'

import * as CardStyles from './styles'
import { getLabels } from './utils'

const CardMain = ({
  title,
  date,
  readingTime,
}: {
  title: string
  date?: number | string
  href?: string
  readingTime?: string
}) => {
  const { ACCESSIBLE_LABELS } = getLabels({ date })
  const truncatedTitle = getTruncatedText({ text: title, maxLength: 65 })

  return (
    <>
      <div className="blog-card__content">
        <AccessibleText
          tag="h3"
          as={HeadingXS}
          title={title}
          text={truncatedTitle}
          accessibleText={title}
        />
        <CardStyles.DateWrapper className="blog-card__infos" color="dark-medium">
          <DateTime date={date} accessibleLabel={ACCESSIBLE_LABELS.publication} />
          {readingTime && <ReadingTime labelReadingTime={readingTime} readingTime=" de leitura" />}
        </CardStyles.DateWrapper>
      </div>
    </>
  )
}

export default CardMain
